// Module
var code = `<div class="breadcrumb-content">
  <ol class="breadcrumbs-list"></ol>
</div>
`;
// Exports
module.exports = code;